module.exports = __webpack_public_path__ + "media/images/athletes/23-16a5a1e33fe01d403aad03700c58d0d0.png";